/* hs-eslint ignored failing-rules */

import { Component } from 'react';
import I18n from 'I18n';
import FormattedList from 'I18n/components/FormattedList';
import { Form } from 'foundations-components/transitional/components/Form';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import Loading from '../components/Loading';
import { Small } from 'foundations-components/transitional/components/Small';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import HubSpotLocaleSelect from 'ui-addon-i18n/components/HubSpotLocaleSelect';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import createAllI18nProvider from 'I18n/init/providers/createAllI18nProvider';
import lang from 'i2l?query=sporks!../../lang/en.lyaml';
import registerAllData from 'I18n/init/register/lazy/registerAllData';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getDisplayLocale = locale => {
  if (!locale) {
    return 'en-us';
  }
  switch (locale) {
    case 'en-nz':
    case 'en-in':
      return 'en-au';
    case 'en-ie':
      return 'en-gb';
    default:
      return locale;
  }
};
class LocaleEditor extends Component {
  componentDidMount() {
    const I18nAllProvider = createAllI18nProvider();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    I18nAllProvider.register(lang);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    registerAllData(I18nAllProvider);
  }
  renderLocaleSample() {
    const {
      locale
    } = this.props;
    const displayLocale = getDisplayLocale(locale);
    return /*#__PURE__*/_jsxs(Small, {
      use: "help",
      children: [I18n.text('userPreferences.labels.format'), ":", ' ', /*#__PURE__*/_jsxs(FormattedList, {
        children: [/*#__PURE__*/_jsx(FormattedDateTime, {
          value: new Date(),
          format: "LL"
        }), /*#__PURE__*/_jsx(FormattedDateTime, {
          value: I18n.moment().locale(displayLocale),
          format: "L"
        }), /*#__PURE__*/_jsx(FormattedDateTime, {
          value: I18n.moment().locale(displayLocale),
          format: "LT zz"
        }), I18n.formatNumber(1234.56,
        //  @ts-expect-error Property 'lookup' does not exist on type 'I18n'.
        I18n.lookup('number.format', {
          locale: displayLocale
        }))]
      })]
    });
  }
  render() {
    const {
      failed,
      isUngatedBetaLanguages,
      loading,
      language,
      locale,
      handleLocaleChanged
    } = this.props;
    if (loading) {
      return /*#__PURE__*/_jsx(Loading, {});
    }
    return /*#__PURE__*/_jsx(Form, {
      children: /*#__PURE__*/_jsx(FormControl, {
        "aria-label": "locale",
        label: I18n.text('userPreferences.labels.locale'),
        tooltip: I18n.text('userPreferences.help.locale'),
        error: failed,
        help: !failed && this.renderLocaleSample(),
        validationMessage: failed && I18n.text('userPreferences.errors.failedToLoadLocale'),
        paddingBlockStart: "0",
        marginBlockEnd: "600",
        children: /*#__PURE__*/_jsx(HubSpotLocaleSelect, {
          "data-test-id": "locale-select",
          disabled: failed,
          language: language,
          value: locale || 'en-us',
          onChange: localeOption => handleLocaleChanged(localeOption),
          useBetaLanguages: isUngatedBetaLanguages
        })
      })
    });
  }
}
export default LocaleEditor;